import { Placeholder } from "semantic-ui-react";
import { isString } from "lodash";

import { CloseButton } from "../../buttons/closeButton";

import "./modalHeader.scss";

export interface ModalHeaderProps {
  title?: string;
  onClose: () => void;
  loading?: boolean;
}

const displayTitle = (title: string | undefined, loading: boolean | undefined) => {
  return isString(title) && !loading ? (
    <span className="title-text">{title}</span>
  ) : (
    <Placeholder data-testid="loading-modal-header">
      <Placeholder.Header />
    </Placeholder>
  );
};

function ModalHeader(props: ModalHeaderProps) {
  const { title, onClose, loading } = props;
  return (
    <div className="modal-header">
      {title ? displayTitle(title, loading) : <div />}

      <CloseButton onClick={onClose} className="close-button" />
    </div>
  );
}

export default ModalHeader;
